var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSylized4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.234375 10.9046C0.234375 4.88216 5.11626 3.24249e-05 11.1393 3.24249e-05C17.161 3.24249e-05 22.0429 4.88216 22.0429 10.9046C22.0429 16.9269 17.161 21.809 11.1393 21.809C5.11626 21.809 0.234375 16.9269 0.234375 10.9046Z",
    fill: "#F8C94F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92598 8.87557C7.92598 9.62346 7.5652 10.2299 7.12128 10.2299C6.67864 10.2299 6.31787 9.62346 6.31787 8.87557C6.31787 8.12768 6.67864 7.52116 7.12128 7.52116C7.5652 7.52116 7.92598 8.12768 7.92598 8.87557Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9599 8.87557C15.9599 9.62346 15.6004 10.2299 15.1564 10.2299C14.7125 10.2299 14.353 9.62346 14.353 8.87557C14.353 8.12768 14.7125 7.52116 15.1564 7.52116C15.6004 7.52116 15.9599 8.12768 15.9599 8.87557Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73438 15.5002C9.73438 15.4999 11.7344 15.4997 14.7344 15.5",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSylized4);
export default __webpack_public_path__ + "static/media/sylized_4.4e89a4eae34fd382b24256f607a71789.svg";
export { ForwardRef as ReactComponent };